export const Category_Inpatient = 'Inpatient';
export const Category_Outpatient = 'Outpatient';
export const Category_Community = 'Community';
export const Category_Discharge = 'Discharge';
export const FHIR_MedicationRequest_CategoryOptions = [
    Category_Inpatient,
    Category_Outpatient,
    Category_Community,
    Category_Discharge,
];
export const FHIR_MedicationRequest_CategoryOptions_ToLabelsMap = {
    [Category_Inpatient]: 'Inpatient',
    [Category_Outpatient]: 'Outpatient',
    [Category_Community]: 'Community',
    [Category_Discharge]: 'Discharge',
};
export const Status_OnHold = 'on-hold';
export const Status_Completed = 'completed';
export const Status_Stopped = 'stopped';
export const Status_Active = 'active';
export const FHIR_MedicationRequest_StatusOptions = [
    Status_OnHold,
    Status_Completed,
    Status_Stopped,
    Status_Active,
];
export const FHIR_MedicationRequest_StatusOptions_ToLabelsMap = {
    [Status_OnHold]: 'On Hold',
    [Status_Completed]: 'Completed',
    [Status_Stopped]: 'Stopped',
    [Status_Active]: 'Active',
};
//# sourceMappingURL=consts.js.map